import { partnerRestService } from "../../services/PartnerRestService";
import { setRewardTypeRes, setRewardTypeMapping } from "./reducer";
export const getRewardTypes = async (input, dispatch) => {
  try {
    const res = await partnerRestService({
      method: "post",
      url: "api/v1/adm/rewardType/list",
      data: input,
    });
    const response = res || {};

    const rewardTypeMapping = {};

    response?.rewardTypes?.forEach((rt) => {
      rewardTypeMapping[rt?.rewardTypeId] = rt;
    });

    dispatch(setRewardTypeMapping(rewardTypeMapping));
    dispatch(setRewardTypeRes(response));

    return response;
  } catch (err) {
    return err;
  }
};
